import dashboard from "./dashboard";
import parking from "./parking";
import booking from "./booking";
import convention from "./convention";
import staff from "./staff";
// import traffic from "./traffic";
import profile from "./profile";
import vnpay from "./vnpay";
import wallet from "./wallet";
import { useSelector } from "react-redux";
import history from "./history";
// import utilities from "./utilities";
// import other from "./other";

// ==============================|| MENU ITEMS ||============================== //

const Menu = () => {
  const token = useSelector((state) => state.token.token);
  const menuItems = {
    items: token
      ? [dashboard, profile, booking, convention, parking, staff, vnpay, wallet, history]
      : [],
  };

  return menuItems;
};

export default Menu;
